import C from './Constants';
import { formatCurrency } from '../../functions';
import { gsap } from 'gsap';

/* PUBLIC CALLBACKS:
 * 
 *   this.props.onSeatClick(data);
 *   this.props.onStateChange(this.state);
 *   
 */

export default class SeatsList {
  constructor(props) {
    this.props = props;

    this.el = $("#SeatsList-Component");

    this.button = this.el.find('.options .btn-find-tickets');
    this.ticketsHeader = this.el.find('.seat-selection .header h5 span');
    this.seatsContainer = this.el.find('.seats');
    this.borderCompensate = this.el.find('.border-compensate');   

    this.section = null;
    this.sectionData = null;
    this.oitemsInSection = null;

    this.availableSeats = null;
    this.listedSeats = [];
    this.groupedSeats = [];
    this.ungroupedSeats = [];
    this.ungroupedIndex = 0;
    this.confirmedSeats = null;



    this.state = C.STATE_SEATS_GROUPED;
    
    this._onSeatClick = this._onSeatClick.bind(this);
    this._onToggleState = this._onToggleState.bind(this);
    this._changeUngroupedIndex = this._changeUngroupedIndex.bind(this);
    this._makeSeatListingChangeable = this._makeSeatListingChangeable.bind(this);
    this._clearUngroupedSeatingListUI = this._clearUngroupedSeatingListUI.bind(this);
    this._changeUngroupedIndex = this._changeUngroupedIndex.bind(this);

    this.ungroupCb = this.el.find('input[type=checkbox]').change(this._onToggleState);

    this.dataStorage = this.props.dataStorage;
    this.lastPickedSeat = "";

  }
    bind() {
        this.state = this.dataStorage.state;
        this.reloadCart();
    }
    _changeUngroupedIndex(e) {
        e.preventDefault();
    }

  /* PUBLIC FUNCTIONS */
  /* -----------------------------*/
  open(section) {
    this.section = section;
    this.reloadCart();

      
  }

  reloadCart() {

    this._updateUI();
    $('.seats .list').empty();
    if (this.dataStorage != null && this.dataStorage.cart != null) {
      let cartItems = this.dataStorage.cart;

      let eventId = parseInt($('.seat-suggestion').data('event-id'));
      let isSeason = JSON.parse($('.seat-suggestion').data('is-season').toLowerCase());
      if (!eventId || isNaN(eventId)) {
        return false;
      }

      let html = [],
        i;

      for (i = 0; i < cartItems.length; i++) {
        let cartItem = cartItems[i],
          template = $('#seat-template').html();

        if (cartItem.eventId === eventId && cartItem.isSeason === isSeason) {
          template = template.replace('{{section}}', cartItem.unSeated ? '-' : cartItem.sectionName);
          // Seatinfo
          Array.prototype.isNull = function () {
            return this.join().replace(/,/g, '').length === 0
          }
          
          let si = cartItem.seatInfo;          
          
          if (si) {
            template = template.replace('{{seatInfo}}', si)
            template = template.replace('{{infoDisplay}}', '');
          } else {
            template = template.replace('{{infoDisplay}}', 'none');
          }

         
          if (cartItem.row) {
            template = template.replace('{{row}}', cartItem.unSeated ? '-' : cartItem.row);
            template = template.replace('{{hideRow}}', '');
          } else {
            template = template.replace('{{row}}', '');
            template = template.replace('{{hideRow}}', 'display:none;');
          }
          template = template.replace('{{seats}}', cartItem.unSeated ? '-' : cartItem.seatNumber);
          template = template.replace('{{price}}', cartItem.unSeated ? '-' : formatCurrency(cartItem.unitPrice + cartItem.serviceFee));

            if (cartItem.seasonConnectedToSubscription) {
                template = template.replace('{{price-col}}', 'd-none')
          }
          template = template.replace('{{type}}', cartItem.ticketName);

          let elementClass = '';
          if (this.section != null && !this.section.oitems.includes(cartItem.id) || !cartItem.seatedTicket) {
            elementClass = 'not-seatable';
          }
          template = template.replace('{{elementClass}}', elementClass);

          html.push(template);
        }
      }

      $('.seats .list').append(html.join(''));

      // Case when tickets cant be group on a section
      if (this.dataStorage.showToggleUngroupCheckbox!=null && !this.dataStorage.showToggleUngroupCheckbox) {
          this.state = C.STATE_SEATS_UNGROUPED;
          this.dataStorage.state = C.STATE_SEATS_UNGROUPED;
        $('.ungroup-option').hide();        
      }

      this.listedSeats = $('.seats .list .seat');
      if (this.dataStorage.state === C.STATE_SEATS_UNGROUPED) {
        this._makeSeatListingChangeable();
        this._setNextSelection();
      } else {
        this._clearUngroupedSeatingListUI();
      }

      
      

    }
  }

  _onSeatClick() {
    this.props.onSeatClick();
  }


  _clearError() {
    let errorEl = $('.section-container .error');
    errorEl.hide();
  }


  _addSeats(cartItems) {    

    let eventId = parseInt($('.seat-suggestion').data('event-id'));
    let isSeason = JSON.parse($('.seat-suggestion').data('is-season').toLowerCase());
    if (!eventId || isNaN(eventId)) {
      return false;
    }

    let html = [],
      i;

    for (i = 0; i < cartItems.length; i++) {
      let cartItem = cartItems[i],
        template = $('#seat-template').html();

      if (cartItem.eventId === eventId && cartItem.isSeason === isSeason) {
        template = template.replace('{{section}}', cartItem.sectionName);
        // Seatinfo
        Array.prototype.isNull = function () {
          return this.join().replace(/,/g, '').length === 0
        }
        let si = cartItem.seatInfo;  
        if (si) {
          template = template.replace('{{seatInfo}}', si)
          template = template.replace('{{infoDisplay}}', '');
        } else {
          template = template.replace('{{infoDisplay}}', 'none');
        }
        template = template.replace('{{row}}', cartItem.row);
        template = template.replace('{{seats}}', cartItem.seatNumber);
        template = template.replace('{{price}}', formatCurrency(cartItem.unitPrice + cartItem.serviceFee));
        if (cartItem.seasonConnectedToSubscription) {

            template = template.replace('{{price-col}}', 'd-none')
        }
        template = template.replace('{{type}}', cartItem.ticketName);                                         

        let elementClass = '';                                                                                
        if (this.section != null && !this.section.oitems.includes(cartItem.id)) {                             
          elementClass = 'not-seatable';
        }
        template = template.replace('{{elementClass}}', elementClass);

        html.push(template);
      }
    }

      $('.seats .list').append(html.join(''));
      this.listedSeats = $('.seats .list .seat');

      if (this.state === C.STATE_SEATS_UNGROUPED) {
          this._setNextSelection();
          this._makeSeatListingChangeable();
      } else {
          this._clearUngroupedSeatingListUI();
      }
    
    
  }

  _setNextSelection() {
    let listedSeatsInDOM = $('.seats .list .seat');
    listedSeatsInDOM.removeClass('next-selection no-border');
    let selIndex = this.dataStorage.GetSelectedSeatIndex();
    var nextSeat = listedSeatsInDOM[selIndex];
    $(nextSeat).addClass('next-selection')

    if (selIndex > 0) {
      $(listedSeatsInDOM[selIndex - 1]).addClass('no-border');
      this.borderCompensate.show();
    } else {
      this.borderCompensate.hide();
    }
  }

    _clearUngroupedSeatingListUI() {
        if (this.listedSeats) {
            this.listedSeats.removeClass('next-selection no-border');
            this.borderCompensate.hide();
            this.listedSeats.removeClass('changeable');
            this.listedSeats.on('click', this._changeUngroupedIndex);
        }
    }

  /* When you click on a row */
  _changeUngroupedIndex(e) {
      if (e.target.className.indexOf("deleteseat") >= 0, e.target.parentElement.className.indexOf("deleteseat") >= 0) {
          // Delete Seat
          
          this._showLoader();
          this.dataStorage.selectedSeat = null;
          this.ungroupedIndex = $(this.listedSeats).index(e.currentTarget);
          var seat = this.dataStorage.cart[this.ungroupedIndex];

          // Remove ticket from cart
          let _this = this;
          jQuery.ajaxSettings.traditional = true;
          $.ajax({
              url: "/cart/RemoveTicket",
              type: 'POST',
              datatype: "json",
              data: jQuery.param({ id: seat.id }),
              traditional: true,
              error: function () {
                  console.log("FEL UPPSTOD!")
              },
              success: function (flag) {
                  if (flag) {
                      _this.dataStorage.init().done(() => {
                          if (_this.dataStorage.cart.length == 0) {
                              let isSeason = JSON.parse($('.seat-suggestion').data('is-season').toLowerCase());
                              if (isSeason) {
                                  window.location.href = "/list/seasons";
                              } else {
                                  window.location.href = "/list/events";
                              }
                          }

                          // Trigger ReservationTimer
                          const startEvent = new Event("cartUpdateEvent");
                          document.dispatchEvent(startEvent);

                          _this.reloadCart();
                          _this._hideLoader();
                          _this.props.onStateChange(_this.state);
                      });
                  } else { _this._hideLoader(); }


              }
          });


      } else {
          // Select Seat
          if (this.state === C.STATE_SEATS_UNGROUPED) {              
              this.ungroupedIndex = $(this.listedSeats).index(e.currentTarget);
              this.dataStorage.selectedSeat = null;
              this.props.onSeatClick(this.ungroupedIndex);
              this._setNextSelection();
          }
      }
      return false;
  }

 _makeSeatListingChangeable() {
    this.listedSeats.on('click', this._changeUngroupedIndex);
    this.listedSeats.addClass('changeable')
  }

  _clearConfirmedSeats() {
    $('.seats .list').empty();
    this.confirmedSeats = [];
  }

  _centerSeatsContainer() {
    if (this.section.startPosition) {
      var x = this.section.startPosition.x - this.section.arenaCords.x;
      var y = this.section.startPosition.y - this.section.arenaCords.y;
      $('.section-seats').css('left', -x);
      $('.section-seats').css('top', -y);
    } else {
      let x = Math.round(($('.section-container').width() - $('.section-seats').width()) * .5);
      let y = Math.round(($('.section-container').height() - $('.section-seats').height()) * .5);

      $('.section-seats').css('left', x);
      $('.section-seats').css('top', y);
    }
  }

  _updateUI() {

    if (!this.dataStorage.cart || !this.dataStorage.cart.length) {
      this.button.hide();
      this.ticketsHeader.text('(0)');
      return;
    }

    this.button.show();
      if (this.dataStorage.cart.length > 0) {
          var index = this.dataStorage.cart.map(function (e) { return e.unSeated; }).indexOf(true);
          if (index >= 0) {
              this.button.hide();
          }
      }
    this.ticketsHeader.text('(' + this.dataStorage.cart.length + ')');

  }
 
  _checkUngroupedOption(numTickets) {
    if (!numTickets || numTickets <= 1) {
      $('.ungroup-option').hide();
    } else {
      $('.ungroup-option').show();
    }
  }

  _hideLoader() {
    let loader = $('.loader');
    loader.hide();
  }

  _showLoader() {    
    let loader = $('.loader');
    loader.show();
  }


    // Listener on checkbox
  _onToggleState(el) {      
    var val = el.target.checked ? el.target.checked : false;      
    if (val) {
        this.state === C.STATE_SEATS_UNGROUPED;
        this.dataStorage.state = C.STATE_SEATS_UNGROUPED;
        $('#choose-section-header input[type=checkbox]').prop('checked', true);
        $('#choose-seats-header input[type=checkbox]').prop('checked', true);
      } else {
        this.state === C.STATE_SEATS_GROUPED;
        this.dataStorage.state = C.STATE_SEATS_GROUPED;
        $('#choose-section-header input[type=checkbox]').prop('checked', false);
        $('#choose-seats-header input[type=checkbox]').prop('checked', false);
      }
    
   this._onSetState();
  }


    _onSetState() {        
        if (this.dataStorage.state === C.STATE_SEATS_UNGROUPED) {
            this.state = C.STATE_SEATS_UNGROUPED;
            this.listedSeats = $('.seats .list .seat');
            this._setNextSelection();
            this._makeSeatListingChangeable();
        } else {
            this.state = C.STATE_SEATS_GROUPED;
            this.dataStorage.state = C.STATE_SEATS_GROUPED;
            this._clearUngroupedSeatingListUI();
        }

        this.props.onStateChange(this.state);
    }

  //
  // ON SELECT SEAT
  // =========================================================================== 

  _onSelectSeat(seat) {
    this.dataStorage.SetSelectedSeat(seat);
  }



}
